import { addDays, isWeekend, parseISO, startOfDay, startOfWeek } from 'date-fns'

import { getDate } from '../../../app/header/utils'
import {
  DividendsEntry,
  DividendsEntryRaw,
  EarningsEntry,
  EarningsEntryRaw,
  EconomicCalendarData,
  EconomicEntry,
  PastNextFuture,
  RawEconomicEntry,
} from './types'

export function processEconomicCalendarData(
  rawData: RawEconomicEntry[],
  now: Date,
  dateFrom: Date
): EconomicCalendarData {
  if (!rawData) {
    return { days: [] }
  }

  let alreadyFuture = false

  const days = rawData.reduce(
    (acc, rawItem) => {
      const date = parseISO(rawItem.date)
      const dateStr = rawItem.date.split('T')[0]

      let type
      if (date < now) {
        type = PastNextFuture.Past
      } else if (alreadyFuture) {
        type = PastNextFuture.Future
      } else {
        type = PastNextFuture.Next
        alreadyFuture = true
      }

      if (date < dateFrom) {
        return acc
      }

      const entry: EconomicEntry = { ...rawItem, parsedDate: date, type }

      if (dateStr in acc) {
        acc[dateStr] = [...acc[dateStr], entry]
      } else {
        acc[dateStr] = [entry]
      }
      return acc
    },
    {} as { [key: string]: EconomicEntry[] }
  )
  return {
    days: Object.keys(days).map((economicDay) => days[economicDay]),
  }
}

export function processEarningsCalendarData(rawData: EarningsEntryRaw[]): EarningsEntry[] {
  return rawData.map((entry) => ({
    ...entry,
    parsedEarningsDate: entry.earningsDate ? parseISO(entry.earningsDate) : undefined,
  }))
}

export function processDividendsCalendarData(rawData: DividendsEntryRaw[]): DividendsEntry[] {
  return rawData.map((entry) => ({
    ...entry,
    parsedExDate: parseISO(entry.exdate),
  }))
}

export function getCalendarTradingDay() {
  const nowNYC = getDate()
  const startNowNYC = startOfWeek(nowNYC, { weekStartsOn: 1 })

  if (isWeekend(nowNYC)) {
    return addDays(startNowNYC, 4)
  }

  return startOfDay(nowNYC)
}
